import gql from 'graphql-tag';
import { RelatedArticlesSectionFragment } from './blog-education-center';

export const ClientReturnsRelatedArticlesQuery = gql`
	query ClientReturnsMarketingPage {
		allClientReturnsLandingPage {
			investorUpdatesSection: relatedArticles {
				...RelatedArticlesSectionFragment
			}
		}
	}
	${RelatedArticlesSectionFragment}
`;
